import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import API from "../Services/VoidTransaction"

const Void = () => {

    const [transaction, setTransaction] = useState([]);
    const [error, setError] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const limit = 10;

    const [mobile, setMobile] = useState("");
    const [remarks, setRemarks] = useState("");
    const [transactionId, setTransactionId] = useState(null);
    const [transactionType, setTransactionType] = useState("non-party");

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];
    const [resetTrigger, setResetTrigger] = useState(0);
    const [search, setSearch] = useState({
        searchText: "",
        from_date: formattedToday,
        to_date: formattedToday,
    });

    useEffect(() => {
        setCurrentPage(1);
        setTransaction([]);
        setTotalRecords(0);
        getVoidTransactions(1);
    }, [transactionType]);

    // useEffect(() => {
    //     getVoidTransactions(currentPage);
    // }, [currentPage, transactionType]);


    useEffect(() => {
        const timer = setTimeout(() => {
            getVoidTransactions(currentPage);
        }, 500);

        return () => clearTimeout(timer);
    }, [currentPage, transactionType, search, mobile]);


    const getVoidTransactions = async (page = currentPage) => {
        try {
            let payload = {
                start_date: search.from_date || formattedToday,
                end_date: search.to_date || formattedToday,
                mobile: mobile || null,
                page_no: page,
                page_size: limit
            };

            if (transactionType === "party") {
                payload.transaction_type = "party";
            }
            const response = await API.getVoidTransactions(payload);
            setTransaction(response?.data?.data || []);
            setTotalRecords(response?.data?.total_count || 0);
        }
        catch (error) {
            if (error?.response?.status === 403) {
                setTimeout(() => {
                    window.location.replace("/login");
                }, 1000);
                return;
            }

            toast.error("Something went wrong. Please try again.");
            console.error(error);
        }
    };
    const totalPages = Math.ceil(totalRecords / limit);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);

            if (left > 2) pageNumbers.push(1, "...");
            for (let i = left; i <= right; i++) pageNumbers.push(i);
            if (right < totalPages - 1) pageNumbers.push("...", totalPages);
        }
        return pageNumbers;
    };
    const handleSearch = async () => {
        setCurrentPage(1);
        getVoidTransactions(1);
    };

    const handleFieldChange = (e, field) => {
        if (field === "remarks") {
            setRemarks(e.target.value);
            setError({ ...error, remarks: "" });
        }
    };

    // const handleFieldChange1 = (e, fieldName) => {
    //     const value = e.target.value;

    //     setSearch((prev) => ({
    //         ...prev,
    //         [fieldName]: value
    //     }));
    // };

    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;

        if (fieldName === "from_date") {
            const newToDate = moment(value).add(90, "days");

            const finalToDate = newToDate.isAfter(moment())
                ? moment().format("YYYY-MM-DD")
                : newToDate.format("YYYY-MM-DD");

            setSearch((prev) => ({
                ...prev,
                from_date: value,
                to_date: finalToDate
            }));
        } else {
            setSearch((prev) => ({
                ...prev,
                [fieldName]: value
            }));
        }
    };
    const handleUpdate = async () => {
        if (!remarks.trim()) {
            setError({ remarks: "Remarks is required" });
            return;
        }

        let payLoad = {
            transaction_id: transactionId,
            reason: remarks,
            voided_by: Number(localStorage.getItem("loginId"))
        };
        if (transactionType === "party") {
            payLoad.transaction_type = "party";
        }
        try {
            const response = await API.voidTransaction(payLoad);
            if (response?.data?.success) {
                toast.success(response?.data?.message || "Updated successfully");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Operation failed");
            }

        } catch (error) {
            console.error(error);
            if (error?.response?.status === 403) {
                localStorage.clear();
                window.location.replace("/Login");
            } else {
                toast.error(
                    error?.response?.data?.message ||
                    "Something went wrong. Please try again."
                );
            }
        }
    };

    const handleReset = () => {
        setSearch({
            searchText: "",
            from_date: formattedToday,
            to_date: formattedToday,
        });
        setMobile("");
        setCurrentPage(1);
        getVoidTransactions(1);
        setResetTrigger((p) => p + 1);
    };
    const handleTransactionTypeChange = (type) => {
        setTransactionType(type);

        setSearch({
            searchText: "",
            from_date: formattedToday,
            to_date: formattedToday,
        });
        setMobile("");
        setCurrentPage(1);
    };
    const columns =
        transaction && transaction.length > 0
            ? Object.keys(transaction[0])
            : [];

    return (
        <div>
            <ToastContainer />

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">

                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Void Transaction</h4>
                    </div>

                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className="d-flex align-items-center gap-5">

                                    <label className="d-flex align-items-center gap-1 mb-0">
                                        {/* <input
                                            type="checkbox"
                                            className="form-check-input m-0"
                                            checked={transactionType === "non-party"}
                                            onChange={() => setTransactionType("non-party")}
                                        /> */}
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0"
                                            checked={transactionType === "non-party"}
                                            onChange={() => handleTransactionTypeChange("non-party")}
                                        />
                                        <span>Non-Party</span>
                                    </label>
                                    <label className="d-flex align-items-center gap-1 mb-0">
                                        {/* <input
                                            type="checkbox"
                                            className="form-check-input m-0"
                                            checked={transactionType === "party"}
                                            onChange={() => setTransactionType("party")}
                                        /> */}
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0"
                                            checked={transactionType === "party"}
                                            onChange={() => handleTransactionTypeChange("party")}
                                        />
                                        <span>Party</span>
                                    </label>

                                </div>
                            </div>

                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label>From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    // value={fromDate || ""}
                                    max={formattedToday}
                                    value={search.from_date || ""}
                                    onChange={(e) => handleFieldChange1(e, "from_date")}
                                // onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>

                            <div className="col-md-4">
                                <label>To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={search.to_date || ""}
                                    min={search.from_date}
                                    max={
                                        search.from_date
                                            ? new Date(
                                                Math.min(
                                                    new Date(search.from_date).setDate(
                                                        new Date(search.from_date).getDate() + 90
                                                    ),
                                                    new Date()
                                                )
                                            ).toISOString().split("T")[0]
                                            : formattedToday
                                    }
                                    onChange={(e) => handleFieldChange1(e, "to_date")}
                                />
                            </div>

                            <div className="col-md-4">
                                <label>Mobile Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter mobile number"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                />
                            </div>

                            <div className="col-md-4 mt-3">
                                <div className="d-flex gap-3">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>

                                    <button
                                        className="btn btn-secondary"
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </button>
                                </div>

                            </div>
                        </div>


                        {/* 📋 TABLE */}
                        {/* <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>Action</th>
                                        <th>Date</th>
                                        <th>Mobile Number</th>
                                        <th>Center Name</th>
                                        <th>Amount</th>
                                        <th>Order Type</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {transaction.length > 0 ? (
                                        transaction.map((item, index) => (
                                            <tr key={index}>

                                                <td>

                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        type="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#myModal"
                                                        onClick={() =>
                                                            setTransactionId(
                                                                transactionType === "party"
                                                                    ? item.party_id
                                                                    : item.order_id
                                                            )
                                                        }
                                                    >
                                                        Void
                                                    </button>

                                                </td>

                                                <td>{moment(item?.order_date).format("DD-MM-YYYY")}</td>
                                                <td>{item?.customer_mobile}</td>
                                                <td>{item?.center_name}</td>
                                                <td>{item?.order_amount}</td>
                                                <td>{item?.order_type}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6">No Record found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <ul className="pagination justify-content-center mt-4">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </div> */}

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>Action</th>

                                        {columns.map((column) => (
                                            <th key={column}>
                                                {column
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {transaction.length > 0 ? (
                                        transaction.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        type="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#myModal"
                                                        onClick={() =>
                                                            setTransactionId(
                                                                transactionType === "party"
                                                                    ? item.party_id
                                                                    : item.order_id
                                                            )
                                                        }
                                                    >
                                                        Void
                                                    </button>
                                                </td>

                                                {columns.map((column) => (
                                                    <td key={column}>
                                                        {column === "order_date"
                                                            ? moment(item[column]).format("DD-MM-YYYY")
                                                            : item[column]}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={columns.length + 1}>
                                                No Record Found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <ul className="pagination justify-content-center mt-4">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section>
                <div className="modal fade" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Remarks</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            <div className="modal-body my-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter remarks"
                                    value={remarks}
                                    onChange={(e) => handleFieldChange(e, "remarks")}
                                />
                                {error?.remarks && (
                                    <span className="text-danger">{error.remarks}</span>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={handleUpdate}>
                                    Confirm
                                </button>
                                <button className="btn btn-secondary" data-bs-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Void;
